export const environment = {
  production: true,
  name: 'Dev',
  apiUrl: 'https://residenz-dev.chapps.com/',
  managerUrl: 'https://manager-residenz-dev.chapps.com'
};
